<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.fullname" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Phone <span class="text-danger">*</span></label>
                    <vue-tel-input :value="currentData.phone" input-class="form-control" mode="international" :auto-format="true" @input="onPhoneChange" />

                    <!-- <input type="text" v-model="currentData.phone" placeholder="" required /> -->
                  </div>
                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Update</button>
                  <router-link to="admin" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch } from "@/assets/js/function";

import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

export default {
  components: {
    VueTelInput,
    
  },
  name: "editlocation",
  data() {
    return {
      filter: true,
      title: "Edit Admin",
      title1: "edit admin info",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",
      googleMap: "",

      //data
      currentData: {
        phone: '',
      },
      currentDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'update')

    this.namaCompany = localStorage.getItem('namaCompany');

    //get data
    this.currentData = JSON.parse(localStorage.getItem('currentData'));
    // this.currentData.phone = '0' + this.currentData.phone.slice(2);
    if (this.currentData.phone && !this.currentData.phone.startsWith('+')) {
      this.currentData.phone = '+' + this.currentData.phone;
    }
    console.log('ini nomor intl:', this.currentData.phone)

  },
 
  methods: {

    onPhoneChange(number, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.currentData.phone = phoneObject.formatted;
        
        
      }

    },


    async insert() {
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const teleponClean = this.currentData.phone.slice(1).replace(/\s+/g, "")
      formData.set("phone", teleponClean);

      // for (let [key, value] of formData.entries()) {
      //     console.log(key, value);
      // }
      // return true

      const api = base_url + '/v3/admin/update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
          AlertBottom(data.message);
          goPage("admin");

          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

     
    },

  },

};
</script>
